export default __webpack_public_path__ + "static/media/OpenSans-VariableFont.ceb05254.ttf";